import { FormHelperText } from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

const ErrorMessage2 = () => {
  const field = useFieldContext();

  return (
    <>
      {field.state.meta.errors.map((err) => (
        <FormHelperText key={err.message} error>
          {err?.message}
        </FormHelperText>
      ))}
    </>
  );
};
export default ErrorMessage2;
